import { render, staticRenderFns } from "./CardGameSearch.vue?vue&type=template&id=3c2226cc&lang=pug&"
import script from "./CardGameSearch.vue?vue&type=script&lang=js&"
export * from "./CardGameSearch.vue?vue&type=script&lang=js&"
import style0 from "./CardGameSearch.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2226cc')) {
      api.createRecord('3c2226cc', component.options)
    } else {
      api.reload('3c2226cc', component.options)
    }
    module.hot.accept("./CardGameSearch.vue?vue&type=template&id=3c2226cc&lang=pug&", function () {
      api.rerender('3c2226cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardGameSearch.vue"
export default component.exports